import "../Styles/workshop.css";
import "../Styles/generalUse.css";
import "../Styles/navBar.css";
import "../Styles/profile.css";

import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Shop from "../pages/Shop";
import Incubator from "../pages/Incubator";
import NavBar from "./NavBar";
import Inventory from "./Inventory";
import HamburgerMenu from "./HamburgerMenu";
import Workbench from "./Workbench";
import Profile from "./Profile";
import ConnectWallet from "./ConnectWallet";
import PhoneMenu from "./PhoneMenu";

function Workshop() {
  const [phoneMenu, setPhoneMenu] = useState(false);

  return (
    <div className="workshop-container">
      <div className="block-1">
        <HamburgerMenu phoneMenu={phoneMenu} setPhoneMenu={setPhoneMenu} />

        <PhoneMenu phoneMenu={phoneMenu} setPhoneMenu={setPhoneMenu} />

        <NavBar />

        <Profile />

        <ConnectWallet />
      </div>
      <div className="block-2">
        <Inventory />

        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Workbench />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/incubator" element={<Incubator />} />
          </Routes>
        </BrowserRouter>
      </div>
    </div>
  );
}

export default Workshop;
